import { Component } from '@angular/core';
import { AuthService } from './auth/auth.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent {
  title = 'Posella Client Manager';

  constructor(private authService: AuthService) {

  }

  isLoggedIn() {
    return this.authService.isloggedin();
  }
  
}
